import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { FolderCounts, NoteList, NoteSearch } from "../../api/schemas/notes";

export const Model = S.Struct({
	page: S.Literal("Knowledge"),
	/** Live list (KTD8: notes are not time-versioned, so no asOf tag): the newest notes in `folder` and below. */
	notes: apiData(NoteList).schema,
	/** The whole circle's folder tree with counts; the tree, Move menu and rename read it, not `notes`. */
	folders: apiData(FolderCounts).schema,
	/** Epoch ms read with the list, for relative "updated" times. */
	now: S.Number,
	/** Tag filter over the loaded list; none shows every note. */
	tag: S.Option(S.String),
	/** Search box text; blank shows the list instead of hits. */
	query: S.String,
	includeRecords: S.Boolean,
	/** Hits for the trimmed `query`; Idle while it is blank. */
	search: apiData(NoteSearch).schema,
	creating: S.Boolean,
	error: S.Option(S.String),
	/** The route's folder: the list shows it and its subfolders; none = all notes. */
	folder: S.Option(S.String),
	/** Folders whose open state differs from the default (see `isExpanded`). */
	toggled: S.Array(S.String),
	/** Folders made here that hold no note yet (folders are implicit on the server). */
	extraFolders: S.Array(S.String),
	/** The inline New folder / Rename folder form. */
	folderForm: S.Option(
		S.Struct({ mode: S.Literals(["create", "rename"]), value: S.String }),
	),
	/** The note whose Move menu is open. */
	moveMenu: S.Option(S.String),
	/** The note being dragged, and the folder row under it. */
	dragging: S.Option(S.String),
	dropTarget: S.Option(S.String),
	/** A move or rename is in flight. */
	moving: S.Boolean,
	/** What the last move did: moved, or links it changed, or its error. */
	notice: S.Option(S.Struct({ text: S.String, error: S.Boolean })),
});
export type Model = typeof Model.Type;
